export default "__VITE_ASSET__1a7a4bde__"